<div class="kanban-view-toolbar px-3 py-2">
  <div class="d-flex align-items-center gap-2">
    <ng-content select="[kanbanToolbar]"></ng-content>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ 'field.search' | translate }}</mat-label>
      <input matInput (keyup)="onSearch($event)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <ng-content select="[itemsViewControls]"></ng-content>
  </div>
</div>
<span class="grey-text f-12" *ngIf="items().length > 90">
  <mat-icon class="s-icon v-middle material-icons-outlined">info</mat-icon>
  {{ 'page.items.kamishibai.tooManyItemsMessage' | translate }}
</span>
<div cdkDropListGroup class="kanban-board d-flex flex-nowrap gx-0 pb-3 px-2">
  @for (column of board(); track column.def.id ?? 'other'; let idx = $index) {
    <div class="w-100">
      <div
        class="kanban-column mx-2"
        [class.drop-allowed]="draggingItem() && allowedColumns()[idx]"
        [class.drop-blocked]="draggingItem() && !allowedColumns()[idx]"
      >
        <div class="header" [class.other]="column.isOther">
          <mat-icon *ngIf="column.isOther">help_outline</mat-icon>
          <span class="header-title">
            {{ column.def.title }}
            <app-count-badge *ngIf="column.items.length" [count]="column.items.length"></app-count-badge>
          </span>
        </div>
        <div class="blocked-overlay" *ngIf="draggingItem() && !allowedColumns()[idx]">
          <mat-icon>block</mat-icon>
          <span>{{ 'page.items.kanban.cannotMoveHere' | translate }}</span>
        </div>
        <div class="drop-targets" *ngIf="draggingItem() && allowedColumns()[idx] && columnTargetSteps()[idx].length">
          <span class="drop-targets-label">{{ 'page.items.kanban.movesTo' | translate }}</span>
          @for (step of columnTargetSteps()[idx]; track step.id) {
            <app-status-category-badge
              [statusCategory]="step.statusCategory"
              [label]="step.isDefault ? ('system.label.' + step.name | translate) : step.name"
            ></app-status-category-badge>
          }
        </div>
        <div
          cdkDropList
          [id]="boardColumnIdPrefix + idx"
          [cdkDropListData]="column.items"
          [cdkDropListEnterPredicate]="canEnterColumn"
          class="scw-kanban-list"
          (cdkDropListDropped)="drop($event, column)"
        >
          @for (item of column.items; track item.id) {
            <div
              class="mb-3 kanban-item"
              cdkDrag
              [cdkDragData]="item"
              (cdkDragStarted)="onDragStarted(item)"
              (cdkDragEnded)="onDragEnded()"
            >
              <app-item-card
                class="item-card"
                [item]="{
                  assigneeName: item.assignee,
                  createdAt: item.createdAt,
                  key: item.itemKey,
                  name: item.title,
                  id: item.id,
                  itemTypeName: item.itemType,
                  itemCategoryName: item.itemCategory,
                  itemType: item.boardItemConfiguration.itemType,
                  itemCategory: item.boardItemConfiguration.itemCategory?.name,
                  dueDate: item.dueDate.original,
                  statusCategory: item.statusCategory,
                  titleIcon: item.titleIcon,
                  boardId: item.boardId,
                  strikeCount: item.strikeCount,
                  priority: item.priority,
                }"
                (cardClick)="openItemEditModal(item.id, item.itemKey, item.boardKey)"
                (triggerRefreshData)="triggerRefreshData()"
              ></app-item-card>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
